/**
 * 取得訂單編號顯示值
 *
 * 優先序：order.metadata.order_number（list / details 白名單都有）
 * → embedded cart 的 metadata（2.21.0+ 可能被後端白名單剝掉而缺失）
 * → display_id → id
 */
export type OrderNumberSource = {
  id: string;
  display_id?: number | string | null;
  metadata?: { order_number?: string | null } | null;
  cart?: { metadata?: { order_number?: string | null } | null } | null;
};

export const getOrderNumber = (order: OrderNumberSource): string =>
  order.metadata?.order_number
  ?? order.cart?.metadata?.order_number
  ?? String(order.display_id ?? order.id);
